import { Link } from 'react-router'

const Footer = () => {
  const date = new Date().getFullYear()
  return (
    <footer className='bg-gray-800 border-t border-gray-700'>
      <div className='max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8'>
        <div className='grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-6'>
          {/* Company */}
          <div>
            <h3 className='text-white font-semibold mb-3'>CloudSoft</h3>
            <p className='text-sm text-gray-400'>
              Independent cloud consulting & backend engineering for startups and small teams.
            </p>
          </div>

          {/* Products */}
          <div>
            <h3 className='text-white font-semibold mb-3'>Products</h3>
            <ul className='space-y-2 text-sm'>
              <li>
                <a href='https://runless.cloud' className='text-gray-400 hover:text-white'>
                  Runless - AWS ECS cost optimisation
                </a>
              </li>
              <li>
                <a href='https://cradesk.eu' className='text-gray-400 hover:text-white'>
                  CRA Desk - Cyber Resilience Act readiness
                </a>
              </li>
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h3 className='text-white font-semibold mb-3'>Navigation</h3>
            <ul className='space-y-2 text-sm'>
              <li>
                <Link to='/services' className='text-gray-400 hover:text-white'>
                  Services
                </Link>
              </li>
              <li>
                <Link to='/company' className='text-gray-400 hover:text-white'>
                  Company
                </Link>
              </li>
              <li>
                <Link to='/contact' className='text-gray-400 hover:text-white'>
                  Contact
                </Link>
              </li>
              <li>
                <Link to='/support' className='text-gray-400 hover:text-white'>
                  Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal & Social */}
          <div>
            <h3 className='text-white font-semibold mb-3'>Legal & Social</h3>
            <ul className='space-y-2 text-sm mb-3'>
              <li>
                <Link to='/terms-of-service' className='text-gray-400 hover:text-white'>
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to='/privacy-policy/v1' className='text-gray-400 hover:text-white'>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to='/cookie-policy' className='text-gray-400 hover:text-white'>
                  Cookie Policy
                </Link>
              </li>
            </ul>
            <div className='flex space-x-3'>
              <a href='https://www.linkedin.com/in/marcin-malinowski-b497a76/' aria-label='LinkedIn'>
                <img src='/images/linkedin.png' width={16} height={16} alt='LinkedIn' />
              </a>
              <a href='https://x.com/CloudSoftComPL' target='_blank' rel='noopener noreferrer' aria-label='X'>
                <img src='/images/x.png' width={16} height={16} alt='X' />
              </a>
            </div>
          </div>
        </div>

        <div className='border-t border-gray-700 pt-6 text-center text-sm text-gray-400'>
          <p>© {date} CloudSoft Marcin Malinowski. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
